// src/portal-app/shell/kit/TabPills.js
//
// Horizontally scrollable pills, each sized to its own label.
//
// Use this instead of SegmentedControl whenever there are four or more
// options: five equal segments across a 393px screen leaves ~70px each and
// the labels nearly collide, which is what made Employee Detail unreadable
// (spec §1 complaint 4, §5 P5).
//
// Accepts `id` or `value` as the option key — the codebase has both shapes
// in existing screens, and normalising here avoids another silent mismatch
// like the one that made two tabs appear active simultaneously (PR #102).
//
// An option may also carry `testId`, rendered as the pill's data-testid.
// Optional and additive — the existing caller (InsightsTab) doesn't pass it
// and is unaffected. Employee Detail (P5) uses it to keep its pre-existing
// `seg-*` testids alive across the SegmentedControl -> TabPills swap,
// rather than rewriting an 18-test suite's selectors.
import React from 'react';
import { ensureKitCss } from './kitCss';

const keyOf = (opt) => (opt.id != null ? opt.id : opt.value);

export function TabPills({ options = [], value, onChange, ariaLabel }) {
    ensureKitCss();
    if (!Array.isArray(options) || options.length === 0) return null;

    return (
        <div className="pk-tabs" role="tablist" aria-label={ariaLabel || undefined}>
            {options.map((opt) => {
                const key = keyOf(opt);
                const active = key === value;
                return (
                    <button
                        key={key}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        className={`pk-tab${active ? ' pk-tab-active' : ''}`}
                        data-testid={opt.testId || undefined}
                        onClick={() => { if (!active && onChange) onChange(key); }}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}

export default TabPills;
